module.exports = __webpack_public_path__ + "img/844.88499749.png";